import { provideZoneChangeDetection } from "@angular/core";
import { registerLocaleData } from '@angular/common';
import skLocale from '@angular/common/locales/sk';
import { bootstrapApplication } from '@angular/platform-browser';
import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import 'reflect-metadata';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

Bugsnag.start({
  apiKey: '7f0a618c6f46d152f55dcb9154406c30',
  releaseStage: environment.stage,
  enabledReleaseStages: ['production', 'staging'],
});

BugsnagPerformance.start({
  apiKey: '7f0a618c6f46d152f55dcb9154406c30',
  releaseStage: environment.stage,
});

registerLocaleData(skLocale);

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch((err) =>
  console.error(err),
);
